import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5 0a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM9.06 11.623c-.386.153-.693.268-.924.348-.23.08-.497.12-.801.12-.467 0-.831-.114-1.09-.342a1.104 1.104 0 0 1-.388-.868c0-.136.01-.276.028-.418.02-.142.051-.302.094-.482l.483-1.707c.042-.164.08-.32.108-.464.03-.146.044-.28.044-.402 0-.217-.045-.37-.135-.455-.09-.086-.262-.128-.516-.128-.125 0-.253.019-.384.058-.13.04-.243.076-.336.111l.127-.525c.317-.13.62-.24.908-.331.29-.093.562-.139.82-.139.464 0 .822.113 1.074.337.25.224.377.515.377.874 0 .074-.01.205-.026.391a2.62 2.62 0 0 1-.097.515l-.48 1.702c-.04.136-.075.293-.106.467a2.47 2.47 0 0 0-.047.397c0 .227.05.38.152.463.1.082.276.123.525.123.118 0 .249-.021.398-.062.147-.04.254-.076.32-.108l-.128.525Zm-.085-6.906a1.147 1.147 0 0 1-.81.312 1.16 1.16 0 0 1-.812-.312.997.997 0 0 1-.339-.758c0-.295.115-.549.339-.759a1.15 1.15 0 0 1 .812-.316c.316 0 .586.105.81.316.224.21.336.464.336.76s-.112.549-.336.757Z",
  fill: "#1C5CE4"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }